import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../../../environments/environment'
import { MODULOS } from 'src/app/core/constants/modulo.constant'

@Injectable({
  providedIn: 'root',
})
export class ReporteService {
  private _http = inject(HttpClient)

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[])

  constructor() {}

  public generar(parametros: any): Observable<any> {
    return this._http.post(`${environment.servidorReportesUrl}/api/v1/${MODULOS.REPORTES}/Generar`, parametros, {
      responseType: 'blob',
    })
  }
}
